const ArrowUpCircleFill = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12.4873 7.03296C12.36 6.90012 12.184 6.825 12 6.825C11.816 6.825 11.64 6.90012 11.5127 7.03296L7.76266 10.946C7.50472 11.2152 7.51381 11.6424 7.78296 11.9004C8.05212 12.1583 8.47941 12.1492 8.73734 11.8801L11.325 9.17991V16.5C11.325 16.8728 11.6272 17.175 12 17.175C12.3728 17.175 12.675 16.8728 12.675 16.5V9.17991L15.2627 11.8801C15.5206 12.1492 15.9479 12.1583 16.217 11.9004C16.4862 11.6424 16.4953 11.2152 16.2373 10.946L12.4873 7.03296Z"
      fill="#007AFF"
    />
  </>
);

export default ArrowUpCircleFill;
